import { StripeBaseData } from "./stripe-base-data";

export class StripeTerminalReaderData extends StripeBaseData{
     public action: any;
     public ipAddress: string;
     public label: string;
     public lastSeenAt: number;
     public livemode: boolean;
     public serialNumber: string;
     public status: string;
     public location: string;
}